import { render, staticRenderFns } from "./SyncPanel.vue?vue&type=template&id=c13982ae&"
import script from "./SyncPanel.vue?vue&type=script&lang=ts&"
export * from "./SyncPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports